import { render, staticRenderFns } from "./theater-event-report.vue?vue&type=template&id=3d12c1ab&scoped=true"
import script from "./theater-event-report.vue?vue&type=script&lang=js"
export * from "./theater-event-report.vue?vue&type=script&lang=js"
import style0 from "./theater-event-report.vue?vue&type=style&index=0&id=3d12c1ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d12c1ab",
  null
  
)

export default component.exports